import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AirbnbOfficialAlterationRequestRepository extends BaseRepositoryService<
  ModelRegistry['airbnb-official-alteration-request']
> {
  recordName = 'airbnb-official-alteration-request';
  implementMethods = ['createRecord'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/airbnb-official-alteration-request': AirbnbOfficialAlterationRequestRepository;
  }
}
